class PredictiveSearch extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.closeSearch = this.querySelector('.close--search');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
        this.closeSearch.addEventListener('click', this.close.bind(this));
    }
    onChange() {
        const searchTerm = this.input.value.trim();
        if (!searchTerm.length) {
            this.close();
            return;
        }
        this.getSearchResults(searchTerm);
    }
    getSearchResults(searchTerm) {

        document.querySelector('.search--spinner-default').classList.add('hidden')
        document.querySelector('.search--spinner').classList.remove('hidden')

        fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`)
        .then((response) => response.json())
        .then((suggestions) => {
            const resourceSuggestions = suggestions.resources;

            this.open()

            document.querySelector('.collectionSuggestions--results').innerHTML = ''
            document.querySelector('.productSuggestions--results').innerHTML = ''
            document.querySelector('.pageSuggestions--results').innerHTML = ''

            let collections = resourceSuggestions.results.collections
            if (collections.length > 0) {
                document.querySelector('#collectionSuggestions').classList.remove('hidden')
                for (let index=0; index < collections.length; index++) {
                    document.querySelector('.collectionSuggestions--results').insertAdjacentHTML("beforeend", this.simpleTemplate(collections[index]))
                }
            } else {
                document.querySelector('#collectionSuggestions').classList.add('hidden')
            }

            let products = resourceSuggestions.results.products
            if (products.length > 0) {
                document.querySelector('#productSuggestions').classList.remove('hidden')
                for (let index=0; index < products.length; index++) {
                    document.querySelector('.productSuggestions--results').insertAdjacentHTML("beforeend", this.productTemplate(products[index]))
                }
            } else {
                document.querySelector('#productSuggestions').classList.add('hidden')
            }

            let pages = resourceSuggestions.results.pages
            if (pages.length > 0) {
                document.querySelector('#pagesSuggestions').classList.remove('hidden')
                for (let index=0; index < pages.length; index++) {
                    document.querySelector('.pageSuggestions--results').insertAdjacentHTML("beforeend", this.simpleTemplate(pages[index]))
                }
            } else {
                document.querySelector('#pagesSuggestions').classList.add('hidden')
            }

            if (collections.length == 0 && pages.length == 0 && products.length == 0) {
                document.querySelector('#noResults').classList.remove('hidden')
            } else {
                document.querySelector('#noResults').classList.add('hidden')
            }

        })
    }
    open() {
        document.querySelector('#predictive-search').classList.remove('hidden')
        document.querySelector('.search--spinner-default').classList.remove('hidden')
        document.querySelector('.search--spinner').classList.add('hidden')
    }
    close() {
        document.querySelector('#predictive-search').classList.add('hidden')
    }
    simpleTemplate(data) {
        return `
            <li class="block text-lg">
                <a class="hover:text-blue-900" href="${data.url}">
                    ${data.title}
                </a>
            </li>
        `
    }
    productTemplate(data) {
        let price
        if ( data.compare_at_price > data.price ) {
            price = '<s class="product-compare-price">'+Shopify.formatMoney(data.compare_at_price, "")+ '</s>&nbsp;<span class="product-price on-sale">'+ Shopify.formatMoney(data.price, "") +'</span>'
        } else {
            price = '<span class="product-price">'+ Shopify.formatMoney(data.price, "") + '</span>'
        }
        let imgSrc
        if (data.featured_image.url) {
            let f = data.featured_image.url.substring(0, data.featured_image.url.lastIndexOf('.'));
            let p = data.featured_image.url.split('.').pop()
            imgSrc = f + '_' + '80x80' + "." + p;
        } else {
            imgSrc = theme.fallbackImageSearch
        }
        return `
            <div class="w-full lg:w-1/2 xl:w-1/3 p-2 flex">
                <div class="w-24">
                    <img class="lazyload min-w-full" src="${imgSrc}">
                </div>
                <div class="flex-1 pl-4">
                    <h4 class="text-lg leading-none">
                        <a class="hover:text-blue-900" href="${data.url}">
                            ${data.title}
                        </a>
                    </h4>
                    <div>${price}</div>
                </div>
            </div>
        `
    }
    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}
customElements.define('predictive-search', PredictiveSearch);